import script from "./user_dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./user_dashboard.vue?vue&type=script&setup=true&lang=js"

import "./user_dashboard.vue?vue&type=style&index=0&id=47f17c49&lang=css"
import "./user_dashboard.vue?vue&type=style&index=1&id=47f17c49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f17c49"]])

export default __exports__